import MerchantLists from '../views/MerchantLists'
import { useStore } from '../state/store'
import { generatePath, RouteMap } from 'lib/router'
import Loading from 'components/Loading'

export const MerchantListsContainer = ({ routes }: { routes: RouteMap }) => {
  const workspaceId = useStore(state => state.workspace.id)
  const organizationId = useStore(state => state.organization.id)

  if (!workspaceId || !organizationId) {
    return <Loading />
  }

  return (
    <MerchantLists
      workspaceId={workspaceId}
      organizationId={organizationId}
      tabPaths={routes.map(route => generatePath(route.path, { workspaceId }))}
    />
  )
}
